document.addEventListener("DOMContentLoaded", function () {
  const parentButtons = document.querySelectorAll(".main-parent-link")

  parentButtons.forEach((button) => {
    button.setAttribute("aria-expanded", "false")
    button.addEventListener("click", function () {
      const wrapper = this.nextElementSibling
      const arrow = this.querySelector(".main-nav-arrow-icon")

      // Toggle current menu state
      const isExpanded = this.classList.toggle("active")
      this.setAttribute("aria-expanded", isExpanded)
      wrapper.classList.toggle("is-open")
      arrow?.classList.toggle("rotate")

      // Automatically open all grandchild links inside this wrapper
      wrapper.querySelectorAll(".grandchild-links").forEach((grandchild) => {
        grandchild.classList.add("is-open")
      })
    })
  })

  // Hamburger click
  const drawerToggle = document.getElementById("Navigation-drawer-button-header")
  const drawerContainer = document.getElementById("Navigation-drawer-header")

  if (drawerToggle && drawerContainer) {
    drawerToggle.setAttribute("aria-expanded", "false")
    drawerToggle.addEventListener("click", function () {
      const isOpen = drawerContainer.classList.contains("is-open")

      // Toggle drawer open class
      drawerContainer.classList.toggle("is-open")
      drawerToggle.setAttribute("aria-expanded", !isOpen)

      // Toggle icon visibility
      drawerToggle.classList.toggle("is-active", !isOpen)
      // Calculate height of announcement bar and header
      const announcementBar = document.querySelector(".section-announcement-bar")
      const header = document.querySelector(".section-header")

      // Calculate their total height
      const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0
      const headerHeight = header ? header.offsetHeight : 0
      const totalHeight = announcementHeight + headerHeight

      document.documentElement.style.setProperty("--header-total-height", totalHeight + "px")

      // Assign the total height to another div (create one for demo)
      const targetDiv = document.querySelector(".drawer__content")
      if (targetDiv) {
        targetDiv.style.top = totalHeight + "px"
      }
    })
  }

  /* Search Customization */
  function findRedirect(searchTerm) {
    const matches = window.searchRedirects.filter((redirect) => {
      if (redirect.matchType === "exact") {
        return searchTerm.toLowerCase() === redirect.searchTerm.toLowerCase()
      } else {
        return searchTerm.toLowerCase().includes(redirect.searchTerm.toLowerCase())
      }
    })
    return matches.sort((a, b) => (b.priority || 1) - (a.priority || 1))[0]
  }

  document.querySelectorAll('form[action="/search"]').forEach((form) => {
    form.addEventListener("submit", function (event) {
      const searchInput = form.querySelector('input[name="q"]')
      if (!searchInput) return

      const searchTerm = searchInput.value.trim()
      const redirect = findRedirect(searchTerm)

      if (redirect) {
        event.preventDefault()
        window.location.href = redirect.redirectUrl
      }
    })
  })

  if (window.location.pathname === "/search") {
    const params = new URLSearchParams(window.location.search)
    const query = params.get("q")
    if (query) {
      const redirect = findRedirect(query)
      if (redirect) {
        window.location.href = redirect.redirectUrl
      }
    }
  }
})
